import {
    /*  Button, Tooltip,  Divider,*/ Collapse,
    Upload,
    message,
    Input,
    Modal,
    Button,
} from 'antd';
import {
    LeftOutlined,
    /*QuestionCircleOutlined, */ CaretRightOutlined,
    DeleteFilled,
    PlusOutlined,
} from '@ant-design/icons';
import {
    /* createHotSpot,  deleteHotSpot */ /* editHotSpot as editHotSpotApi ,*/
    editAlbum,
    createShare,
    uploadFile,
} from '@/api/hdd/album';
import { logoQRcodeGenerate } from '&/utils/commonForPC';
import { createUUID, hddDownload } from '&/utils/common';
import AlbumModal from './selectAlbumModal';
import wordIcon from '@/assets/img/hdd/word.png';
import pictureIcon from '@/assets/img/hdd/picture.png';
// import testImg from '@/assets/img/hdd/1024_576.jpg';
import uploadIcon from '@/assets/img/hdd/Icon-Upload.png';
import { useEffect } from 'react';
import './index.scss';

const { Panel } = Collapse;
const { TextArea } = Input;

export default function PanoramaEditPanel(props) {
    const acceptList = ['.gif', '.jpg', '.jpeg', '.png', '.bmp'];
    const acceptAttr = acceptList.toString(',');
    const [headUrl, setHeadUrl] = useState('');
    const {
        active,
        isPanoramaVrRoom = true,
        handleAddHot,
        handleEditHotSpot,
    } = props;
    const focusInput = useRef();
    const isFileSelectPendingRef = useRef(false);

    const dispatchAtlasFun = action => {
        try {
            window.external.DispatchFun('Atlas', action, '');
        } catch (error) {
            console.log('error', error);
        }
    };

    const handleUploadClick = () => {
        isFileSelectPendingRef.current = true;
        console.log('AtlasBeforeSelectFile');
        dispatchAtlasFun('AtlasBeforeSelectFile');
        const onWindowFocus = () => {
            window.removeEventListener('focus', onWindowFocus);
            window.setTimeout(() => {
                if (!isFileSelectPendingRef.current) {
                    return;
                }
                isFileSelectPendingRef.current = false;
                console.log('AtlasAfterSelectFile setimeout');
                dispatchAtlasFun('AtlasAfterSelectFile');
            }, 300);
        };

        window.addEventListener('focus', onWindowFocus);
    };

    // const schemeId =
    //     new URLSearchParams(window.location.search).get('schemeId')
    const renderId = new URLSearchParams(window.location.search).get('id');
    const editType = new URLSearchParams(window.location.search).get('type');

    const UPLOAD_CONFIG = {
        multiple: false,
        maxCount: 1,
        accept: acceptAttr,
        showUploadList: false,
        onClick: handleUploadClick,
        // disabled: !permission.includes('entLoadDrawing'),
        customRequest: params => {
            const { file, onSuccess, onError } = params;
            let formData = new FormData();
            formData.append('file', file);
            console.log('file', file);
            // formData.append('file', file);
            formData.append('uuid', createUUID());
            formData.append('type', '9');
            formData.append('fileName', file.name);
            // return
            uploadFile(formData)
                .then(res => {
                    setHeadUrl(res.data.fullFilePath);
                    editAlbum({
                        headUrl: res.data.fullFilePath,
                        renderId: props.tipPosition[active].id,
                    }).then(() => {
                        props.setVrRoomHotList(prev => {
                            if (!prev?.[active]) return;
                            prev[active].headUrl = res.data.fullFilePath;
                            return [...prev];
                        });
                    });
                    onSuccess(res, file);
                })
                .catch(err => {
                    onError(err);
                })
                .finally(() => {});
        },
        // action: process.env.REACT_APP_BASE_URL + '/space/common/upload',
        // 上传图片前验证
        beforeUpload(file) {
            isFileSelectPendingRef.current = false;

            const SUFFIX = file.name
                .substring(file.name.lastIndexOf('.'))
                .toLowerCase();

            if (!acceptList.includes(SUFFIX)) {
                message.error(
                    intl.get('baseComponents.baseTip.fileFormat', {
                        fileFormat: 'gif,jpg,jpeg,png,bmp',
                    })
                );
                return false;
            }

            return file;

            // const MAX_SIZE = 1024 * 1024;
            // if (file.size > MAX_SIZE) {
            //     console.log('file------', file);
            //     message.error(
            //         intl.get('baseComponents.baseTip.fileFormat', { max: '1M' })
            //     );
            //     return false;
            // }

            // return new Promise(function (resolve, reject) {
            //     const maxWidth = 480,
            //         maxHeight = 480;
            //     let reader = new FileReader();
            //     reader.readAsDataURL(file);
            //     reader.onload = function (theFile) {
            //         let image = new Image();
            //         image.src = theFile.target.result;
            //         image.onload = function () {
            //             const w = this.width;
            //             const h = this.height;
            //             if (
            //                 (maxWidth && w > maxWidth) ||
            //                 (maxHeight && h > maxHeight)
            //             ) {
            //                 message.error(
            //                     intl.get(
            //                         'baseComponents.baseTip.updatePictureSizeWrong',
            //                         { w, h }
            //                     )
            //                 );
            //                 reject(
            //                     new Error(
            //                         intl.get(
            //                             'baseComponents.baseTip.pictureSizeWrong'
            //                         )
            //                     )
            //                 );
            //             }
            //             resolve(file);
            //         };
            //     };
            // });
        },
        onChange({ file, fileList, event }) {
            if (file.status === 'done') {
                message.success(
                    intl.get('baseComponents.baseTip.fileUploadSuccessful', {
                        fileName: file.name,
                    })
                );
            }
            console.log('---------test');
            // focusInput.current.focus();
            // focusInput.current.blur()
            console.log('AtlasAfterSelectFile onChange');
            dispatchAtlasFun('AtlasAfterSelectFile');
            // console.log('AtlasCloseFile');
            // window.external.DispatchFun('Atlas', 'AtlasCloseFile', '');
        },
    };

    const [name, setName] = useState('');

    const [codeImgUrl, setCodeImgUrl] = useState('');

    const nameChange = e => {
        setName(e.target.value);
    };

    const onNameChange = () => {
        console.log('name', name);
        if (name === '') {
            message.error('名称不能为空');
            return;
        }
        editAlbum({
            username: name,
            renderId: props.tipPosition[active].id,
        }).then(() => {
            props.setVrRoomHotList(prev => {
                if (!prev?.[active]) return;
                prev[active].username = name;
                return [...prev];
            });
        });
    };

    /* const [title, setTitle] = useState('');

    const titleChange = e => {
        setTitle(e.target.value);
    };

    const [desc, setDesc] = useState('');

    const descChange = e => {
        setDesc(e.target.value);
    }; */

    const [activeStyle, setActiveStyle] = useState(1);

    const [hotName, setHotName] = useState(undefined);
    const [hotDesc, setHotDesc] = useState(undefined);

    const hotNameChange = e => {
        setHotName(e.target.value);
    };

    const hotDescChange = e => {
        setHotDesc(e.target.value);
    };

    const [hotPicture, setHotPicture] = useState('');

    const [pictureType, setPictureType] = useState(0);

    const UPLOAD_CONFIG_PICTURE = {
        ...UPLOAD_CONFIG,
        customRequest: params => {
            const { file, onError } = params;
            let formData = new FormData();
            formData.append('file', file);
            formData.append('uuid', createUUID());
            formData.append('type', '9');
            formData.append('fileName', file.name);
            uploadFile(formData)
                .then(res => {
                    console.log('res', res.data);
                    setHotPicture(res.data.fullFilePath);
                    setPictureType(1);
                    message.success(
                        intl.get(
                            'baseComponents.baseTip.fileUploadSuccessful',
                            {
                                fileName: file.name,
                            }
                        )
                    );
                })
                .catch(err => {
                    onError(err);
                })
                .finally(() => {});
        },
    };

    const onDeleteHotPicture = () => {
        setHotPicture('');
        setPictureType(0);
    };

    const [visible, setVisible] = useState('block');

    const onAddHot = () => {
        setSpotMode('ADD');
        initSpotData({
            text: undefined,
            desc: undefined,
            picture: '',
            styleType: 1,
        });
        setVisible('none');
    };

    const onUploadLocal = () => {
        // setHotPicture(testImg);
        setPictureType(0);

        setSelectAlbumVisible(true);
    };

    const [spotMode, setSpotMode] = useState('ADD');

    const editId = useRef('');
    const vrRoomIndex = useRef(0);

    const initSpotData = spot => {
        setHotName(spot.text);
        setHotDesc(spot.desc);
        setHotPicture(spot.picture);
        setPictureType(spot.illustrationFrom);

        setActiveStyle(spot.styleType);
    };

    const onEditHotSpot = (spot, index) => {
        if (index !== active && editType === 'panoramaVrRoom') {
            props.onPanoramaChange(index);
        }

        props.setCameraPosition(spot);
        vrRoomIndex.current = index;
        initSpotData(spot);
        setVisible('none');
        editId.current = spot.id;
        setSpotMode('EDIT');
    };

    const handleDeleteHotSpot = hotSpotId => {
        Modal.confirm({
            title: null,
            icon: null,
            content: `确认删除吗`,
            okText: '确认',
            cancelText: '取消',
            onOk: close => {
                props.handleDeleteHotSpot(hotSpotId);
                close();
            },
            onCancel: close => {
                close();
            },
        });
    };

    const onAddHotConfirm = () => {
        if (spotMode === 'EDIT') {
            handleEditHotSpot(
                {
                    id: editId.current,
                    text: hotName,
                    styleType: activeStyle,
                    picture: hotPicture,
                    desc: hotDesc,
                    mode: spotMode,
                    vrRoomIndex: vrRoomIndex.current,
                    illustration: pictureType,
                    illustrationFrom: pictureType,
                },
                vrRoomIndex.current
            ).then(() => {
                setVisible('block');
            });
        } else if (spotMode === 'ADD') {
            handleAddHot({
                text: hotName,
                styleType: activeStyle,
                picture: hotPicture,
                desc: hotDesc,
                mode: spotMode,
                illustration: pictureType,
                illustrationFrom: pictureType,
            }).then(() => {
                setVisible('block');
            });
        }
    };

    async function getCodeUrl(url) {
        const code = await logoQRcodeGenerate({
            url,
        });
        setCodeImgUrl(code);
    }

    const [copyUrl, setCopyUrl] = useState('');

    const copyInput = useRef();
    // 两种方式复制到剪切板
    const copyLink = async copyUrl => {
        if (!copyUrl) return;
        const { clipboard } = navigator;
        try {
            if (!clipboard) throw new Error();
            await clipboard.writeText(copyUrl);
        } catch {
            copyInput.current.select();
            document.execCommand('copy');
        } finally {
            message.success('复制成功，粘贴至微信或QQ即可分享！');
        }
    };

    const handleDownload = url => {
        // 下载
        console.log('url', url);
        hddDownload([url]);
    };
    useEffect(() => {
        createShare({
            renderId,
            type: editType === 'panorama' ? 1 : 2,
            title: 'test',
        }).then(res => {
            console.log('res', res);
            console.log(
                'res.data.url',
                '/pages/hdd/panoramaShare?panorama=1&shareCode=' +
                    res.data.shareCode
            );
            let url =
                res.data.domain +
                '/pages/hdd/panoramaShare?panorama=0&shareCode=' +
                res.data.shareCode;
            getCodeUrl(url);
            setCopyUrl(url);
        });
    }, []);

    useEffect(() => {
        if (props.tipPosition.length) {
            setName(props.tipPosition[active].username || '');
            setHeadUrl(props.tipPosition[active].headUrl);
        }
    }, [props.tipPosition, active]);

    const [selectAlbumVisible, setSelectAlbumVisible] = useState(false);

    const handleSelectAlbumOk = selected => {
        console.log('selected', selected);
        setHotPicture(selected.coverImageUrl);
        setSelectAlbumVisible(false);
    };

    return (
        <>
            <div className="left-panel" style={{ display: 'block' }}>
                <Collapse
                    bordered={false}
                    defaultActiveKey={['1', '2', '3']}
                    expandIcon={({ isActive }) => (
                        <CaretRightOutlined rotate={isActive ? 90 : 0} />
                    )}
                    className="site-collapse-custom-collapse"
                    expandIconPosition="right">
                    <Panel header="基本信息" key="1" className="base-info">
                        <div className="info-item">
                            <div className="label">头像</div>
                            <Upload
                                name="file"
                                listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                {...UPLOAD_CONFIG}>
                                {headUrl ? (
                                    <div className="avatar-wrap">
                                        <img
                                            className="avatar"
                                            style={{ width: 'l00%' }}
                                            src={headUrl}
                                            alt={intl.get(
                                                'baseComponents.baseInfo.foxitHomeDecorationCloudServices'
                                            )}
                                        />
                                        <div className="mark">
                                            <img src={uploadIcon}></img>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div>
                                            <PlusOutlined />
                                        </div>
                                    </div>
                                )}
                            </Upload>
                        </div>
                        <div className="info-item">
                            <div className="label">昵称</div>
                            <Input
                                placeholder="请输入名称"
                                suffix={`${name.length}/30`}
                                maxLength={30}
                                value={name}
                                onChange={nameChange}
                                onBlur={onNameChange}
                                onPressEnter={onNameChange}
                                onKeyPress={e => {
                                    e.stopPropagation();
                                }}
                                onKeyDown={e => {
                                    e.stopPropagation();
                                }}
                                onKeyUp={e => {
                                    e.stopPropagation();
                                }}
                            />
                        </div>
                    </Panel>
                    <Panel header="图文热点 " key="2" className="picture-word">
                        <div className="btn-wrap">
                            <Button className="btn" onClick={onAddHot}>
                                <PlusOutlined />
                                新增图文热点
                            </Button>
                        </div>
                        {isPanoramaVrRoom ? <div className="line"></div> : null}
                        {editType === 'panoramaVrRoom' &&
                            props.vrRoomHotList.map((item, index) => {
                                return (
                                    <div className="spot-item" key={index}>
                                        <div
                                            className={`spot-item-name ${
                                                active === index ? 'active' : ''
                                            }`}>
                                            {item.title}
                                        </div>
                                        <div className="spot-list">
                                            {item.hopSpotList.map(spot => {
                                                return (
                                                    <div
                                                        className="spot"
                                                        key={spot.id}>
                                                        <img
                                                            src={
                                                                spot.picture
                                                                    ? pictureIcon
                                                                    : wordIcon
                                                            }></img>
                                                        <div
                                                            className={`spot-name`}>
                                                            {spot.text}
                                                        </div>
                                                        <div className="spot-btn">
                                                            <i
                                                                style={{
                                                                    fontSize: 14,
                                                                }}
                                                                onClick={() => {
                                                                    onEditHotSpot(
                                                                        spot,
                                                                        index
                                                                    );
                                                                }}
                                                                // onClick={openForm}
                                                                className="filled icon-pencil pointer"></i>
                                                            <DeleteFilled
                                                                className="pointer"
                                                                onClick={() => {
                                                                    handleDeleteHotSpot(
                                                                        spot.id
                                                                    );
                                                                }}
                                                                style={{
                                                                    fontSize: 14,
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}

                        {editType === 'panorama' &&
                            props.hotList.map(spot => {
                                return (
                                    <div className="spot" key={spot.id}>
                                        <img
                                            src={
                                                spot.picture
                                                    ? pictureIcon
                                                    : wordIcon
                                            }></img>
                                        <div className={`spot-name`}>
                                            {spot.text}
                                        </div>
                                        <div className="spot-btn">
                                            <i
                                                style={{ fontSize: 14 }}
                                                onClick={() => {
                                                    onEditHotSpot(spot);
                                                }}
                                                // onClick={openForm}
                                                className="filled icon-pencil pointer"></i>
                                            <DeleteFilled
                                                className="pointer"
                                                onClick={() => {
                                                    handleDeleteHotSpot(
                                                        spot.id
                                                    );
                                                }}
                                                style={{ fontSize: 14 }}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                    </Panel>
                    <Panel header="分享" key="3" className="share">
                        {/* <div className="label">标题</div>
                        <Input
                            placeholder="请输入标题"
                            value={title}
                            onChange={titleChange}
                        />
                        <div className="label">描述</div>
                        <Input
                            placeholder="请输入辅助文案，如未编辑则不显示（仅针对微信分享）"
                            value={desc}
                            onChange={descChange}
                        /> */}
                        {/* <div className="line"></div> */}
                        <Input
                            ref={copyInput}
                            value={copyUrl}
                            readOnly
                            style={{ position: 'fixed', top: 100000 }}
                        />
                        <div className="label">扫码分享</div>
                        <div className="qrcode">
                            <img src={codeImgUrl}></img>
                            <Button
                                className="btn"
                                onClick={() => handleDownload(codeImgUrl)}>
                                下载二维码
                            </Button>
                            <br />
                            <Button
                                className="btn"
                                onClick={() => copyLink(copyUrl)}>
                                复制链接
                            </Button>
                        </div>
                    </Panel>
                </Collapse>
            </div>
            <div
                className="left-add-panel"
                style={{ display: visible === 'block' ? 'none' : 'block' }}>
                <div
                    className="left-add-panel-back"
                    onClick={() => {
                        setVisible('block');
                    }}>
                    <LeftOutlined />
                    设置图文热点
                </div>
                <div className="title">样式</div>
                <div className="style-wrap">
                    <div
                        onClick={() => setActiveStyle(1)}
                        className={`style-item style-item-1 ${
                            activeStyle === 1 ? 'active' : ''
                        }`}>
                        <div>
                            <div className="hot-img"></div>
                            <div className="content">text</div>
                        </div>
                    </div>
                    <div
                        onClick={() => setActiveStyle(2)}
                        className={`style-item style-item-2 ${
                            activeStyle === 2 ? 'active' : ''
                        }`}>
                        <div>
                            <div className="hot-img"></div>
                            <div className="content">text</div>
                        </div>
                    </div>
                </div>
                <div className="title title-info">信息</div>
                <div className="info">
                    <div className="info-label">标题</div>
                    <Input
                        placeholder="请输入名称"
                        suffix={`${hotName ? hotName?.length : 0}/20`}
                        maxLength={20}
                        value={hotName}
                        ref={focusInput}
                        onKeyPress={e => {
                            e.stopPropagation();
                        }}
                        onKeyDown={e => {
                            e.stopPropagation();
                        }}
                        onKeyUp={e => {
                            e.stopPropagation();
                        }}
                        className={hotName === '' ? 'error' : ''}
                        onChange={hotNameChange}
                    />
                    <div
                        className={`error-tip ${
                            hotName === '' ? 'error' : ''
                        }`}>
                        {'热点名称不能为空'}
                    </div>
                    <div className="info-label">描述</div>
                    <TextArea
                        placeholder="请输入名称"
                        maxLength={300}
                        value={hotDesc}
                        showCount={{
                            formatter: info => {
                                return info.count + '/' + info.maxLength;
                            },
                        }}
                        onKeyPress={e => {
                            e.stopPropagation();
                        }}
                        onKeyDown={e => {
                            e.stopPropagation();
                        }}
                        onKeyUp={e => {
                            e.stopPropagation();
                        }}
                        className={hotDesc === '' ? 'error' : ''}
                        onChange={hotDescChange}
                    />
                    <div
                        className={`error-tip ${
                            hotDesc === '' ? 'error' : ''
                        }`}>
                        {'热点详情不能为空'}
                    </div>
                    <div className="line"></div>
                    <div className="info-label">配图</div>
                    <div className="upload-img">
                        {hotPicture ? (
                            <div className="hot-picture-preview">
                                <img src={hotPicture} />
                                <div
                                    className="delete"
                                    onClick={onDeleteHotPicture}>
                                    <DeleteFilled />
                                </div>
                            </div>
                        ) : (
                            <div className="add-picture-wrap">
                                <div
                                    className="local-upload"
                                    onClick={onUploadLocal}>
                                    <div>
                                        <PlusOutlined />
                                        <div>从图册添加</div>
                                    </div>
                                </div>
                                <Upload
                                    listType="picture-card"
                                    className="avatar-uploader-1"
                                    showUploadList={false}
                                    {...UPLOAD_CONFIG_PICTURE}>
                                    {
                                        <div>
                                            <div>
                                                <PlusOutlined />
                                                <div>本地上传</div>
                                            </div>
                                        </div>
                                    }
                                </Upload>
                            </div>
                        )}
                    </div>
                </div>
                <div className="footer">
                    <Button
                        onClick={() => {
                            setVisible('block');
                        }}>
                        取消
                    </Button>
                    <Button type="primary" onClick={onAddHotConfirm}>
                        保存
                    </Button>
                </div>
            </div>
            <AlbumModal
                visible={selectAlbumVisible}
                setVisible={setSelectAlbumVisible}
                handleOk={handleSelectAlbumOk}
            />
        </>
    );
}
